// extracted by mini-css-extract-plugin
export default {"changerList":"Changer_changerList__tOFIa","changerContent":"Changer_changerContent__-MZBR"};